import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateWebhook } from '../../../../common/api/clients/webhooks.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useWebhookUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateWebhook,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.webhooks.list._def });
        },
    });
};
